/* eslint-disable react-hooks/set-state-in-effect */
import { useState, useEffect } from 'react';

const useDetectDevice = () => {
  const [deviceType, setDeviceType] = useState('Desktop');

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    if (/android/i.test(userAgent)) {
      setDeviceType('Android');
      return;
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      setDeviceType('iOS');
      return;
    }
    if (/windows phone/i.test(userAgent)) {
      setDeviceType('Windows Phone');
      return;
    }
    if (/tablet|ipad|playbook|silk/i.test(userAgent)) {
      setDeviceType('Tablet');
      return;
    }
    if (
      /Mobile|Android|iP(ad|hone|od)|IEMobile|Kindle|Silk-Accelerated|webOS|BlackBerry|Opera Mini/i.test(
        userAgent,
      )
    ) {
      setDeviceType('Mobile');
      return;
    }
    setDeviceType('Desktop');
  }, []);

  return deviceType;
};

export default useDetectDevice;
